import React from "react";
import WidgetBattery from "../WidgetBattery";

function GasSensorBatteryWidget() {
  return (
    <div className="widget">
      <div className="dashboard-widget-title">
        <h1 className="dashboard-widget-title-name">가스 감지 센서</h1>
        <p className="dashboard-widget-title-place">장소</p>
      </div>
      <div className="dashboard-widget-footer">
        <WidgetBattery battery={10} />
        <span>10%</span>
      </div>
    </div>
  );
}

export default GasSensorBatteryWidget;
